import { Component, inject, input } from '@angular/core';

import { MatTooltip } from "@angular/material/tooltip";
import { MatBottomSheet, MatBottomSheetConfig } from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { ApiService } from "../../../services/api.service";
import { SpinnerService } from "../../../shared/spinner/spinner.service";
import { ChatDocumentService } from "../services/chat-document.service";
import { ChatSessionService } from "../services/chat-session.service";
import { SessionDetailsListComponent } from "./session-details-list/session-details-list.component";
import { IDocument } from "../../../interfaces/i-document";
import { IAgentSummary } from "../../../interfaces/i-agents";

/**
 * Session Details for popup window
 */
@Component({
  selector: 'session-details',
  imports: [
    MatButtonModule,
    MatIcon,
    MatTooltip,
    MatMenuModule
],
  templateUrl: './session-details.component.html',
  styleUrl: './session-details.component.scss'
})
export class SessionDetailsComponent {
  isMenuItem = input<boolean>(false);
  agents: IAgentSummary[] = [];
  documents: IDocument[] = [];

  #bottomSheet = inject(MatBottomSheet);
  #apiService = inject(ApiService);
  #spinnerService = inject(SpinnerService);
  #chatDocumentService = inject(ChatDocumentService);
  #chatSessionService = inject(ChatSessionService);

  open() {
    this.documents = this.#chatDocumentService.getAllDocumentsInTheSession(this.#chatSessionService.selectedSession()!);;
    const agentIds: string[] = this.#chatSessionService.selectedSession()?.agents || [];

    if (agentIds.length > 0) {
      this.#getSessionAgents(agentIds);
    } else {
      this.#openBottomSheet();
    }
  }

  #openBottomSheet() {
    const session = this.#chatSessionService.selectedSession();
    const model = session?.model?.accountName && session?.model?.model
      ? `${session.model.accountName}/${session.model.model}`
      : 'None set';
    const config: MatBottomSheetConfig = {
      hasBackdrop: true,
      panelClass: [ 'notification-bottom-sheet' ],
      autoFocus: "first-heading",
      data: {
        agents: this.agents,
        documents: this.documents,
        meta: {topP: session?.topP, temperature: session?.temperature, model },
      }
    };

    this.#bottomSheet.open(SessionDetailsListComponent, config);
  }

  #getSessionAgents(agentIds: string[]) {
    // Get the agent ids from the selected session
    this.#spinnerService.show();
    // Get the agents label
    this.#apiService.getAgentsByIds(agentIds).subscribe({
      next: agents => {
        this.agents = agents;
        this.#spinnerService.hide();
        this.#openBottomSheet();
      },
      error: error => {
        console.error('Error getting agents', error);
        this.#spinnerService.hide();
      }
    });
  }
}
